import {
  IBusinessEntitySummary,
  IBusinessEntitySummaryPage,
} from '@commenda/types';
import { fetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

const getSummariesOfCompany = async (
  companyId: number,
  token: string | undefined,
  cursor: number | null = null
): Promise<IBusinessEntitySummary[]> => {
  const query = new URLSearchParams({
    companyId: String(companyId),
    limit: '100',
  });
  if (cursor !== null) query.append('cursor', String(cursor));

  const response = await fetcher(
    `business-entities/summaries?${query}`,
    { method: 'GET' },
    token
  );
  if (!response.ok) throw new Error('Failed to fetch business entities');

  const page = (await response.json()) as IBusinessEntitySummaryPage;
  return page.nextCursor === null
    ? page.entities
    : [
        ...page.entities,
        ...(await getSummariesOfCompany(companyId, token, page.nextCursor)),
      ];
};

/** `companyId` of null skips the request, for a caller that renders before a company is chosen. */
export function useGetCorporationByCompany(
  companyId: number | null,
  token?: string | undefined
) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: IBusinessEntitySummary[];
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<IBusinessEntitySummary[]>;
  } = useSWR(
    companyId === null ? null : ['business-entities/summaries', companyId],
    () => getSummariesOfCompany(companyId!, token)
  );

  if (error) {
    console.error(error);
  }

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
